import React, { useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Tabs } from '@hmsexp/component-library';
import { View } from '../Common/react-native-components';
import styles from './styles';

const WebViewTabs = ({ navItems }) => {
  const location = useLocation();
  const history = useHistory();

  const activeTabId = useMemo(() => {
    const activeItem = navItems.find(item => location.pathname.includes(item.path));
    return activeItem ? activeItem.id : navItems[0]?.id;
  }, [location.pathname, navItems]);

  const handleTabClick = tabId => {
    const item = navItems.find(i => i.id === tabId);
    if (item) {
      history.push(item.path);
    }
  };

  const tabsData = useMemo(
    () =>
      navItems.map(item => ({
        id: item.id,
        title: item.title,
        isVisible: true
      })),
    [navItems]
  );

  return (
    <View style={styles.navbarFixedPositionedContent}>
      <Tabs
        style={{
           wrapper: styles.tabWrapper,
            tabItem: styles.tabItem
           }}
        tabs={tabsData}
        onTabClick={handleTabClick}
        selectedTabId={activeTabId}
      />
    </View>
  );
};

export default WebViewTabs;
